import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { FeedbackStudentsPreviewModel } from "common/models/page-models/Feedback students preview/feedback-students-preview-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class FeedbackStudentPreviewDataService extends FormDataService<FeedbackStudentsPreviewModel> {
    constructor(http: SmApiService, protected override  ss: SystemService) {
        super(API_URL.feedbackPreview, http, ss);
    }

    getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.feedbackPreview,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        // console.log(data, 'getUpdatePayload');

        let payload;
        payload = {
            student_id: data.transferData.student_id,
            feedback_Form_Id: data.transferData.feedback_Form_Id,
            feedback_form_mapping_id: data.transferData.feedback_form_mapping_id,

        }
        return payload;
    }

    createInstance(): FeedbackStudentsPreviewModel {
        return new FeedbackStudentsPreviewModel();
    }

    override modifyAPIResponse(response: any) {
        return response['details'];
    }

    override getUpdateUrl() {
        return '';
    }

}